import * as React from 'react';
export const context = React.createContext();
export default context;
